export const COLLECTION_NAMES = {
    USERS: 'users',
    BANNERS: 'banners',
    FIELDS: 'fields',
    UNIVERSITIES: 'universities',
    FEED: 'feed',
    POLITICSANDABOUT: 'politicsAndAbout',
    ABOUT_US: 'aboutUs',
    PRIVACYPOLICY: 'privacyPolicy',
    SCHOLARSHIPS: 'scholarships',
    CHAT: 'chat',
    EVENTS: 'event',
    SCHEDULE: 'schedule',
    SCHEDULE_CONFIG: 'schedule_config',
    MATCH_PAGE: 'matchPage',
    PLANS: 'plan',
    PHASES: 'phases',
    TRACKS: 'tracks',
    LESSONS: 'lessons',
    COMMENTS: 'comments',
    TRACK_COMPLETE: 'trackCompletions',
    COMPLETED_BY: 'completedBy',
    ACCESSED_BY: 'accessedBy',
    PRODUCT: 'products',
    SERVICE: 'services',
    WALLET: 'wallet',
    COUPON: 'coupon',
    TENANT: 'tenants',
    BADGES: 'badges',
    MISSIONS: 'missions'
};